<template>
	<div>
		<button class="uk-button uk-button-small uk-button-primary uk-width-1-1" @click="shortenUrl">
			<span v-show="!loading">Genereer Bitly</span>
			<LoadingIndicator :size="30" v-show="loading" />
		</button>
	</div>
</template>

<script>
import axios from 'axios';
import LoadingIndicator from './LoadingIndicator.vue'

export default {
	components: { LoadingIndicator },	
	props: {
		apiKey: {
			type: String,
			required: true
		},
		longUrl: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			shortUrl: null,
			loading: false
		};
	},
	methods: {
		async shortenUrl() {
			
			if(!this.longUrl) {
				this.$logger('app/components/bitly-generator/shortenUrl/no-input-url');
				return;
			}
			
			const apiEndpoint = 'https://api-ssl.bitly.com/v4/bitlinks';
			const apiKey = this.apiKey;

			this.loading = true;
			
			try {
				const response = await axios.post(apiEndpoint, {
					long_url: this.longUrl
				}, {
					headers: {
						'Authorization': `Bearer ${apiKey}`,
						'Content-Type': 'application/json'
					}
				});

				this.loading = false;
				this.shortUrl = response.data.link;
				//let modifiedUrl = this.shortUrl.replace("https://", "");
	
				await navigator.clipboard.writeText(this.shortUrl);
				alert('Url van artikel naar clipboard gekopieerd');		
				
			} catch (error) {
				console.error('Error creating short URL:', error);
				this.loading = false;
			}
		}
	}
};
</script>
